import React from "react";
import { Avatar, InputAdornment } from "@mui/material";

import {
	checkboxCheckedPrimaryIcon,
	checkboxCheckedWhiteIcon,
	checkboxDefaultOutlineIcon,
	radioCheckedPrimaryIcon,
	radioUncheckedDefaultIcon,
	checkboxWhiteOutlineIcon,
} from "../assets/images/index";

export const radioDefaultIcon = (
	<Avatar variant="square" src={radioUncheckedDefaultIcon} />
);

export const radioCheckedIcon = (
	<Avatar variant="square" src={radioCheckedPrimaryIcon} />
);

export const checkboxDefaultIcon = (
	<Avatar variant="square" src={checkboxDefaultOutlineIcon} />
);

export const checkBoxCheckedIcon = (
	<Avatar variant="square" src={checkboxCheckedPrimaryIcon} />
);

export const checkboxWhiteCheckedIcon = (
	<Avatar variant="square" src={checkboxCheckedWhiteIcon} />
);

export const checkboxOutlineWhiteIcon = (
	<Avatar variant="square" src={checkboxWhiteOutlineIcon} />
);

export const startAdornment = (
	<InputAdornment position="start" className="disabled">
		R
	</InputAdornment>
);

export const VisibilityIcon: React.FC<{ fillColor?: string }> = ({
	fillColor = "rgb(118, 118, 118)",
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height="24px"
			viewBox="0 0 24 24"
			width="24px"
			fill={fillColor}
		>
			<path d="M0 0h24v24H0z" fill="none" />
			<path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
		</svg>
	);
};

export const VisibilityOffIcon: React.FC<{ fillColor?: string }> = ({
	fillColor = "rgb(118, 118, 118)",
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height="24px"
			viewBox="0 0 24 24"
			width="24px"
			fill={fillColor}
		>
			<path
				d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
				fill="none"
			/>
			<path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
		</svg>
	);
};

export const CalendarEventAvailableIcon: React.FC<{ fillColor?: string }> = ({
	fillColor = "#0bc46b",
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height="24px"
			viewBox="0 0 24 24"
			width="24px"
			fill={fillColor}
		>
			<path d="M0 0h24v24H0V0z" fill="none" />
			<path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm5.56 10.46l5.93-5.93-1.06-1.06-4.87 4.87-2.11-2.11-1.06 1.06z" />
		</svg>
	);
};

export const CalendarEventPrimaryIcon: React.FC<{ fillColor?: string }> = ({
	fillColor = "#034F8B",
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			enableBackground="new 0 0 24 24"
			height="24px"
			viewBox="0 0 24 24"
			width="24px"
			fill={fillColor}
		>
			<rect fill="none" height="24" width="24" />
			<path d="M5,10h14v2h2V6c0-1.1-0.9-2-2-2h-1V2h-2v2H8V2H6v2H5C3.89,4,3.01,4.9,3.01,6L3,20c0,1.1,0.89,2,2,2h7v-2H5V10z M5,6h14v2H5 V6z M22.84,16.28l-0.71,0.71l-2.12-2.12l0.71-0.71c0.39-0.39,1.02-0.39,1.41,0l0.71,0.71C23.23,15.26,23.23,15.89,22.84,16.28z M19.3,15.58l2.12,2.12l-5.3,5.3H14v-2.12L19.3,15.58z" />
		</svg>
	);
};

export const CalendarEventWarningIcon: React.FC<{ fillColor?: string }> = ({
	fillColor = "#fac402",
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height="24px"
			viewBox="0 0 24 24"
			width="24px"
			fill={fillColor}
		>
			<path d="M0 0h24v24H0V0z" fill="none" />
			<path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm3.23 9.41l1.06 1.06 2.44-2.44 2.44 2.44 1.06-1.06-2.44-2.44 2.44-2.44-1.06-1.06-2.44 2.44-2.44-2.44-1.06 1.06 2.44 2.44z" />
		</svg>
	);
};

export const CommentIcon: React.FC<{
	fillColor?: string;
	height?: string;
	width?: string;
	margin?: string;
}> = ({
	fillColor = "#bababa",
	height = "20px",
	width = "21px",
	margin = "",
}) => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 21 20"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			style={{
				fillRule: "evenodd",
				clipRule: "evenodd",
				strokeLinejoin: "round",
				strokeMiterlimit: "1.41421",
				height: height,
				width: width,
				margin: margin,
			}}
		>
			<path
				d="M7,9c-0.198,0 -0.391,0.059 -0.556,0.169c-0.164,0.109 -0.292,0.266 -0.368,0.448c-0.076,0.183 -0.095,0.384 -0.057,0.578c0.039,0.194 0.134,0.372 0.274,0.512c0.14,0.14 0.318,0.235 0.512,0.274c0.194,0.038 0.395,0.019 0.578,-0.057c0.182,-0.076 0.338,-0.204 0.448,-0.368c0.11,-0.165 0.169,-0.358 0.169,-0.556c0,-0.265 -0.105,-0.52 -0.293,-0.707c-0.188,-0.188 -0.442,-0.293 -0.707,-0.293Zm4,0c-0.198,0 -0.391,0.059 -0.556,0.169c-0.164,0.109 -0.292,0.266 -0.368,0.448c-0.076,0.183 -0.095,0.384 -0.057,0.578c0.039,0.194 0.134,0.372 0.274,0.512c0.14,0.14 0.318,0.235 0.512,0.274c0.194,0.038 0.395,0.019 0.578,-0.057c0.182,-0.076 0.339,-0.204 0.448,-0.368c0.11,-0.165 0.169,-0.358 0.169,-0.556c0,-0.265 -0.105,-0.52 -0.293,-0.707c-0.188,-0.188 -0.442,-0.293 -0.707,-0.293Zm4,0c-0.198,0 -0.391,0.059 -0.556,0.169c-0.164,0.109 -0.292,0.266 -0.368,0.448c-0.076,0.183 -0.095,0.384 -0.057,0.578c0.039,0.194 0.134,0.372 0.274,0.512c0.14,0.14 0.318,0.235 0.512,0.274c0.194,0.038 0.395,0.019 0.578,-0.057c0.182,-0.076 0.339,-0.204 0.448,-0.368c0.11,-0.165 0.169,-0.358 0.169,-0.556c0,-0.265 -0.105,-0.52 -0.293,-0.707c-0.188,-0.188 -0.442,-0.293 -0.707,-0.293Zm-4,-9c-1.313,0 -2.614,0.259 -3.827,0.761c-1.213,0.503 -2.316,1.239 -3.244,2.168c-1.876,1.875 -2.929,4.419 -2.929,7.071c-0.009,2.309 0.791,4.549 2.26,6.33l-2,2c-0.139,0.141 -0.233,0.319 -0.27,0.513c-0.038,0.194 -0.017,0.395 0.06,0.577c0.083,0.18 0.218,0.331 0.387,0.434c0.169,0.104 0.365,0.154 0.563,0.146l9,0c2.652,0 5.196,-1.054 7.071,-2.929c1.875,-1.875 2.929,-4.419 2.929,-7.071c0,-2.652 -1.054,-5.196 -2.929,-7.071c-1.875,-1.875 -4.419,-2.929 -7.071,-2.929Zm0,18l-6.59,0l0.93,-0.93c0.094,-0.093 0.17,-0.203 0.221,-0.325c0.052,-0.122 0.078,-0.253 0.079,-0.385c-0.004,-0.264 -0.112,-0.515 -0.3,-0.7c-1.31,-1.308 -2.125,-3.03 -2.307,-4.871c-0.183,-1.842 0.279,-3.69 1.306,-5.229c1.027,-1.54 2.557,-2.676 4.327,-3.214c1.771,-0.538 3.674,-0.446 5.384,0.261c1.71,0.707 3.123,1.985 3.996,3.617c0.874,1.632 1.155,3.516 0.795,5.331c-0.36,1.815 -1.338,3.45 -2.768,4.625c-1.429,1.175 -3.222,1.818 -5.073,1.82Z"
				style={{ fill: fillColor, fillRule: "nonzero" }}
			/>
		</svg>
	);
};

export const ChangeRequestIcon: React.FC<{
	fillColor?: string;
	height?: string;
	width?: string;
	margin?: string;
}> = ({
	fillColor = "#034F8B",
	height = "22px",
	width = "22px",
	margin = "",
}) => {
	return (
		<svg
			style={{
				width: height,
				height: width,
				verticalAlign: "middle",
				fill: fillColor,
				overflow: "hidden",
				margin: margin,
			}}
			viewBox="0 0 1024 1024"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M199.04 369.92h170.88a83.84 83.84 0 0 0 85.12-85.12V113.92A83.84 83.84 0 0 0 369.92 28.8H199.04a83.84 83.84 0 0 0-85.12 85.12V284.8a85.76 85.76 0 0 0 85.12 85.12z m-28.16-256a26.88 26.88 0 0 1 28.16-28.16h170.88a26.88 26.88 0 0 1 28.16 28.16V284.8a26.88 26.88 0 0 1-28.16 28.16H199.04a26.88 26.88 0 0 1-28.16-28.16zM841.6 654.08H640a69.12 69.12 0 0 0-68.48 68.48v204.8A69.12 69.12 0 0 0 640 995.2h204.8a69.12 69.12 0 0 0 68.48-68.48v-204.8a69.12 69.12 0 0 0-68.48-68.48z m8.32-181.76h-39.68l71.04 122.24 71.04-122.24h-45.44a398.08 398.08 0 0 0-394.88-358.4v56.96a343.68 343.68 0 0 1 338.56 301.44z m-676.48 82.56h39.68l-70.4-122.24-71.04 122.24h45.44a397.44 397.44 0 0 0 394.88 355.2v-56.96a341.12 341.12 0 0 1-338.56-298.24z m0 0"
				style={{ fill: fillColor, fillRule: "nonzero" }}
			/>
		</svg>
	);
};

export const FullScreenIcon: React.FC = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960">
			<path
				d="M120 936V636h60v198l558-558H540v-60h300v300h-60V318L222 876h198v60H120Z"
				style={{
					fill: "#034f8b",
					fillRule: "nonzero",
				}}
			/>
		</svg>
	);
};

export const MilestoneIcon: React.FC<{ color?: string }> = ({
	color = "#034f8b",
}) => {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width="60.000000pt"
			height="67.000000pt"
			viewBox="0 0 60.000000 67.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g
				transform="translate(0.000000,67.000000) scale(0.100000,-0.100000)"
				fill={color}
				stroke="none"
			>
				<path
					d="M148 340 c2 -136 0 -200 -7 -200 -6 0 -11 -4 -11 -10 0 -5 11 -10 25
-10 14 0 25 5 25 10 0 6 -5 10 -11 10 -7 0 -9 62 -7 200 2 129 -1 200 -7 200
-6 0 -9 -71 -7 -200z"
				/>
				<path
					d="M193 493 c-9 -3 -13 -31 -13 -89 0 -81 1 -84 19 -74 29 15 97 12 114
-5 8 -8 17 -11 21 -8 11 12 6 83 -9 119 -19 46 -87 76 -132 57z"
				/>
				<path
					d="M389 433 l-36 -4 5 -49 c3 -35 0 -57 -11 -74 -20 -31 -14 -36 44 -36
80 0 86 7 43 51 l-37 38 22 36 c23 39 25 46 14 43 -5 -1 -24 -3 -44 -5z"
				/>
			</g>
		</svg>
	);
};

export const CollapseDownIcon: React.FC<{
	fillColor?: string;
}> = ({ fillColor = "#034F8B" }) => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 16 16"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			style={{
				fillRule: "evenodd",
				clipRule: "evenodd",
			}}
		>
			<path
				d="M1.642,4.465c0.188,-0.188 0.442,-0.293 0.707,-0.293c0.265,0 0.52,0.105 0.707,0.293l4.95,4.949l4.95,-4.949c0.189,-0.183 0.441,-0.283 0.703,-0.281c0.263,0.002 0.513,0.107 0.699,0.293c0.185,0.185 0.29,0.436 0.293,0.698c0.002,0.262 -0.099,0.515 -0.281,0.704l-5.657,5.656c-0.187,0.188 -0.442,0.293 -0.707,0.293c-0.265,0 -0.519,-0.105 -0.707,-0.293l-5.657,-5.656c-0.187,-0.188 -0.293,-0.442 -0.293,-0.707c0,-0.266 0.106,-0.52 0.293,-0.707Z"
				style={{
					fill: fillColor,
					fillRule: "nonzero",
					stroke: fillColor,
					strokeWidth: "0.5px",
				}}
			/>
		</svg>
	);
};

export const CollapseRightIcon: React.FC<{
	fillColor?: string;
}> = ({ fillColor = "#034F8B" }) => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 16 16"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			style={{
				fillRule: "evenodd",
				clipRule: "evenodd",
				transform: "rotate(-90deg)",
			}}
		>
			<path
				d="M1.642,4.465c0.188,-0.188 0.442,-0.293 0.707,-0.293c0.265,0 0.52,0.105 0.707,0.293l4.95,4.949l4.95,-4.949c0.189,-0.183 0.441,-0.283 0.703,-0.281c0.263,0.002 0.513,0.107 0.699,0.293c0.185,0.185 0.29,0.436 0.293,0.698c0.002,0.262 -0.099,0.515 -0.281,0.704l-5.657,5.656c-0.187,0.188 -0.442,0.293 -0.707,0.293c-0.265,0 -0.519,-0.105 -0.707,-0.293l-5.657,-5.656c-0.187,-0.188 -0.293,-0.442 -0.293,-0.707c0,-0.266 0.106,-0.52 0.293,-0.707Z"
				style={{
					fill: fillColor,
					fillRule: "nonzero",
					stroke: fillColor,
					strokeWidth: "0.5px",
				}}
			/>
		</svg>
	);
};

export const PanelIcon: React.FC<{
	fillColor?: string;
}> = ({ fillColor = "#034F8B" }) => {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width="85%"
			height="100%"
			viewBox="0 0 200.000000 200.000000"
			preserveAspectRatio="none"
		>
			<g
				transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
				fill="#000000"
				stroke="none"
			>
				<path
					d="M330 1542 c-108 -59 -108 -212 0 -269 52 -28 82 -29 137 -3 46 21 77
62 88 117 8 42 -26 117 -67 146 -39 29 -115 33 -158 9z"
				/>
				<path
					d="M927 1538 c-73 -43 -98 -152 -50 -217 37 -48 71 -66 128 -66 116 0
187 113 136 217 -39 81 -136 111 -214 66z"
				/>
				<path
					d="M1529 1537 c-46 -30 -82 -104 -74 -150 11 -55 42 -96 88 -117 55 -26
85 -25 137 3 108 57 108 211 0 268 -48 26 -109 24 -151 -4z"
				/>
				<path
					d="M315 1207 c-53 -30 -98 -92 -120 -166 l-19 -61 -73 0 -73 0 0 -30 0
-30 975 0 975 0 0 30 0 30 -73 0 -73 0 -19 61 c-42 141 -161 221 -268 180 -65
-25 -137 -120 -152 -204 l-7 -37 -83 0 -82 0 -7 41 c-14 85 -84 177 -153 200
-48 16 -116 6 -159 -22 -43 -29 -91 -99 -105 -153 -5 -23 -12 -47 -14 -53 -3
-9 -29 -13 -84 -13 l-79 0 -7 37 c-30 161 -181 257 -300 190z"
				/>
				<path d="M80 665 l0 -245 925 0 925 0 0 245 0 245 -925 0 -925 0 0 -245z" />
			</g>
		</svg>
	);
};

export const DownArrowRedIcon: React.FC = () => {
	return (
		<svg
			width="20px"
			height="20px"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			stroke="#e13636"
			style={{ transform: "rotate(180deg)" }}
		>
			<g id="SVGRepo_bgCarrier" stroke-width="0" />
			<g
				id="SVGRepo_tracerCarrier"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<g id="SVGRepo_iconCarrier">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M12 3C12.2652 3 12.5196 3.10536 12.7071 3.29289L19.7071 10.2929C20.0976 10.6834 20.0976 11.3166 19.7071 11.7071C19.3166 12.0976 18.6834 12.0976 18.2929 11.7071L13 6.41421V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V6.41421L5.70711 11.7071C5.31658 12.0976 4.68342 12.0976 4.29289 11.7071C3.90237 11.3166 3.90237 10.6834 4.29289 10.2929L11.2929 3.29289C11.4804 3.10536 11.7348 3 12 3Z"
					fill="#e13636"
				/>
			</g>
		</svg>
	);
};

export const ChatIcon: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="25"
			version="1.1"
			viewBox="0 0 25 25"
		>
			<image
				width="25"
				height="25"
				xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAxCAYAAABznEEcAAAAAXNSR0IArs4c6QAABNpJREFUaEPtWW9MG2Ucft+7XqHtgLZ3ZRswGCiKWyJuIyQbU8wWdG4wAyIFY0ymxmjMiHFZ4gcT+WIyNdP4wWXxw/xkCug0/pmLZAOUTecGW1gQ1FmQuNLA9YD1L/TPveZuFmHeeu/blqYQ+qlJn9/ze573ef/dFYJV8IGrwANYM5EuKa4lcWcSn4whozPsZYAHgALa53+ufIMvFWnFlcQ3E4g7PDDd8Zcf7SERWWRgXh2vzTlBUoODJTJh+Jwf90VgIQ6xGqbYQL09Vmt+Uw2H8zueiXY+BCDU4BCSYlgtPCfUszWkdYvxMU1kdAoj8wiVJdIAt9ZamLGlY2fWCC5e1URbD9K0TQmheAgTqdHTwO5v5O4l5VBOosOFSInU8Bt11ICZAQO3QsgBAYzoaMiGENo27g+Xi4gyRespMRIUW9ZnqPHFTiIJBsqNmtOtRaFDL5RZPCRiJOy+Pnd9l2PeJjZbMnFrlyaRgAEaQU+kmc1eaNyDNMyk688QhEW4Yk5uz9n1cinzMy4+ilswYTjNj/rCsJiUwADBVV8Tt0OqO9A3W3JmImwn5VDCV3GaVy7uNZ7E4ZJNIIQg7BREnILFmP4mVlsBYeix3tmarslwF2k9Dr5ET387Wmeqi4WVTejaBXsAohIc0tsY5ARWS5781caHALU8Z8hiPfUF2l1fVmUrTrXb04lgLWzUwivOeray5aJ/p+2m/yd844kjKQjsYtP/t2AiE3oaDvsb2a17e2c+PD8ZaU1cVpwMVm7JhgSfuISyz44Lt9TpxBCw5mofPj/zWp8r8oE6fvkQFAIBsZnTL+xOZefc7G9C0KXa0srB/n7EVNiFoCo2BYCCTGi7+ST7jNQKHrzAZ33tgO5YfSkIrolN3HaStZMCHwD8O63w1oSVg9u6ZqqvzUR6UyIOt4kIeNDC5WKbSLsUokatHJRN5H3F903Mwd1KA1Bppj+9XGN6Nl1NPLVJ+8B/W9VdzopCg8ZcuzkYOvErRXyZw50VieAyaehWNdFWyeo+GvYZee+cM5Fmy1mLaYI38l5q5ZooyGHYFznfXJtdm5LXL6SJZTHoupzE7m7fjgt8oF+J4P4s6uzv+83703VhV5l0+bKJ8u9nOwdnw0/fdRSkQ4Xgkkg6mgnho1vsYoE0Ap5IMyc/oZV+J5y64UGHpJOx5bJnq21sfiihhkkuhgA4kZXLk5NgPpsUjj+UW9ZaCnmlPuYvhB+mG9hq0MEHAYBMkrXET7fk2kFCkybTqjxH88bgPuM78gWQRL+EbfnR+6DNOTdIWpdMfCYtjsw15m6JchKbkArfGwk8evS6ryeZwrC5EBoHzZbNi/FxmZAIjvS7ueP2oOIawhZECNykozr/Pmi23lkWt4kokabdNRWGwEKohxi+joGj3gb2HqXChE1IpKduIMvzV4UpYmUEBflaeMVRz1Yum4ko8VtDQ9pjw+sd8whyBPqwoPet09j+OGCUH0eTPp1iKajpcR/rngwejkCw8FCvLEIMmRj60nQD+4j0u67dNRKAYMlfCvl6+n1HnelIyk1gDXEsUMdUBACKkiAGBr7ua2AV37IkZU0kLDYGQfGZ6XfHvOLRPRs0j3dXGxVflaa9CdkfQvClgUDlxxX6X1bedMKMeGUkoWJmzQRm2ssOWxVJ/AObYJypcLxiPgAAAABJRU5ErkJggg=="
			/>
		</svg>
	);
};

export const EyeIcon: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="25"
			xmlSpace="preserve"
			version="1.1"
			viewBox="0 0 25 25"
			style={{
				justifyContent: "center",
				verticalAlign: "middle",
			}}
		>
			<image
				width="25"
				height="25"
				xlinkHref="data:image/png;base64,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"
			/>
		</svg>
	);
};

export const FullyCreditedIcon: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="25"
			xmlSpace="preserve"
			version="1.1"
			viewBox="0 0 25 25"
			style={{
				justifyContent: "center",
				verticalAlign: "middle",
			}}
		>
			<image
				width="25"
				height="25"
				xlinkHref="data:image/png;base64,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"
			/>
		</svg>
	);
};

export const FullyPaidIcon: React.FC = () => {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="25"
			viewBox="0 0 200.000000 200.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g
				transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
				fill="#000000"
				stroke="none"
			>
				<path
					d="M753 1875 c-277 -50 -501 -221 -621 -473 -115 -242 -108 -511 20
-752 188 -354 597 -524 985 -409 41 12 72 27 70 33 -1 6 -11 39 -21 73 l-19
62 -34 -14 c-19 -8 -67 -21 -108 -30 -332 -68 -665 121 -787 447 -27 71 -32
100 -35 203 -6 146 10 224 68 342 79 160 233 293 405 349 80 26 102 29 219 29
109 0 141 -4 199 -23 239 -80 408 -256 472 -493 18 -67 25 -251 12 -300 l-8
-27 73 -4 c39 -2 75 0 78 5 3 5 9 41 12 81 14 159 -32 356 -115 500 -56 97
-209 247 -308 303 -173 97 -371 132 -557 98z"
				/>
				<path
					d="M830 1477 c0 -54 0 -54 -37 -65 -88 -27 -153 -116 -153 -211 0 -127
92 -208 248 -220 76 -6 87 -10 108 -34 33 -39 31 -81 -5 -118 -27 -27 -35 -29
-105 -29 -72 0 -76 1 -98 30 -20 27 -27 30 -80 30 -52 0 -58 -2 -58 -20 0 -63
69 -144 137 -162 l43 -10 0 -55 0 -54 63 3 62 3 5 55 c5 52 6 55 40 64 19 6
55 31 81 56 92 89 92 208 -1 301 -52 52 -102 69 -200 69 -51 0 -65 4 -85 25
-36 35 -35 97 1 130 24 22 36 25 100 25 61 0 78 -4 94 -20 11 -11 20 -24 20
-30 0 -10 112 -14 122 -5 3 3 1 24 -5 47 -13 53 -71 112 -124 128 -42 13 -42
13 -45 64 l-3 51 -62 3 -63 3 0 -54z"
				/>
				<path
					d="M1499 806 c-99 -26 -186 -103 -231 -203 -29 -64 -32 -197 -5 -262 45
-110 134 -188 247 -217 254 -64 490 172 426 426 -49 196 -242 309 -437 256z
m256 -236 c7 -22 7 -22 -104 -153 -40 -48 -81 -87 -90 -87 -25 0 -116 116
-116 148 0 46 34 41 80 -12 l40 -46 70 85 c73 88 107 106 120 65z"
				/>
			</g>
		</svg>
	);
};

export const PartiallyCreditedIcon: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="25"
			xmlSpace="preserve"
			version="1.1"
			viewBox="0 0 25 25"
			style={{
				justifyContent: "center",
				verticalAlign: "middle",
			}}
		>
			<image
				width="25"
				height="25"
				xlinkHref="data:image/png;base64,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"
			/>
		</svg>
	);
};

export const PartiallyPaidIcon: React.FC = () => {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="25"
			viewBox="0 0 225.000000 225.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g
				transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)"
				fill="#000000"
				stroke="none"
			>
				<path
					d="M966 2190 c-427 -68 -770 -378 -884 -798 -23 -87 -26 -115 -25 -267
0 -151 3 -181 26 -267 101 -379 395 -674 772 -775 90 -24 118 -26 270 -26 154
0 179 2 270 27 186 51 352 146 486 278 61 60 169 200 169 218 0 7 -71 43 -74
38 -125 -194 -310 -348 -501 -417 -122 -44 -219 -61 -349 -61 -277 0 -500 92
-697 289 -196 196 -289 420 -289 696 0 276 93 500 289 696 196 196 420 289
696 289 263 0 491 -90 678 -269 72 -69 183 -208 173 -218 -2 -2 -72 14 -156
37 -84 23 -156 38 -161 33 -5 -5 -10 -24 -11 -43 l-3 -34 219 -58 c121 -31
221 -56 222 -55 2 1 26 94 54 207 28 113 53 213 56 222 4 13 -4 19 -33 27 -21
6 -40 11 -43 11 -3 0 -21 -61 -40 -135 -19 -74 -38 -134 -42 -133 -4 2 -23 26
-43 53 -136 193 -373 352 -615 414 -97 25 -316 36 -414 21z"
				/>
				<path
					d="M1100 1546 c0 -20 -7 -25 -47 -35 -124 -31 -189 -108 -187 -221 0
-41 7 -77 18 -98 21 -40 92 -87 164 -108 l52 -15 0 -109 0 -108 -37 10 c-42
11 -96 41 -129 70 -21 19 -22 19 -63 -31 l-42 -50 33 -24 c49 -37 126 -73 186
-87 52 -12 52 -12 52 -51 0 -38 1 -39 35 -39 34 0 35 1 35 39 0 38 1 39 41 46
133 23 208 105 209 228 0 108 -58 173 -190 213 l-60 18 0 104 0 104 38 -7 c20
-3 57 -17 81 -31 24 -13 45 -23 46 -22 37 48 63 93 59 100 -11 18 -107 57
-166 69 -51 10 -58 14 -58 35 0 21 -5 24 -35 24 -30 0 -35 -3 -35 -24z m0
-246 l0 -100 -37 15 c-62 25 -85 72 -61 122 11 24 67 63 91 63 4 0 7 -45 7
-100z m124 -270 c41 -15 66 -47 66 -84 0 -42 -23 -71 -72 -91 l-38 -15 0 100
c0 55 4 100 9 100 5 0 21 -4 35 -10z"
				/>
			</g>
		</svg>
	);
};

export const DoubleArrowLeftIcon: React.FC = () => {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width="40"
			height="40"
			viewBox="0 0 200.000000 200.000000"
			preserveAspectRatio="xMidYMid meet"
			style={{ transform: "rotate(180deg)" }}
		>
			<g
				transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
				fill="#767676"
				stroke="none"
			>
				<path
					d="M617 1293 l-57 -58 117 -117 118 -118 -118 -118 -117 -117 58 -58 57
-57 175 175 175 175 -175 175 -175 175 -58 -57z"
				/>
				<path
					d="M1035 1290 l-60 -60 115 -115 115 -115 -115 -115 -115 -115 60 -60
60 -60 175 175 175 175 -175 175 -175 175 -60 -60z"
				/>
			</g>
		</svg>
	);
};

export const DoubleArrowRightIcon: React.FC = () => {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width="40"
			height="40"
			viewBox="0 0 200.000000 200.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g
				transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
				fill="#767676"
				stroke="none"
			>
				<path
					d="M617 1293 l-57 -58 117 -117 118 -118 -118 -118 -117 -117 58 -58 57
-57 175 175 175 175 -175 175 -175 175 -58 -57z"
				/>
				<path
					d="M1035 1290 l-60 -60 115 -115 115 -115 -115 -115 -115 -115 60 -60
60 -60 175 175 175 175 -175 175 -175 175 -60 -60z"
				/>
			</g>
		</svg>
	);
};
